// extracted by mini-css-extract-plugin
export default {"content":"DiscountsModal__content--L0Rbd","loadingBlock":"DiscountsModal__loadingBlock--1crBZ","title":"DiscountsModal__title--2hbJt"};